import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./modules/layout/Layout";
import NewsList from "./modules/news/NewsList";
import NotFound from "./modules/misc/NotFound";
import NewsEdit from "./modules/news/NewsEdit";
import PromoList from "./admin/promo/PromoList";
import PromoForm from "./admin/promo/PromoForm";
import Protected from "./modules/auth/Protected";
import LoginPage from "./modules/auth/LoginPage";
import AssistantFeedbackPage from "./modules/assistant/AssistantFeedbackPage";
import AssistantHistoryPage from "./modules/assistant/AssistantHistoryPage";
import { ASSISTANT_REVIEW_ROLES, isAssistantReviewPortal } from "./modules/assistant/reviewAccess";

const App: React.FC = () => {
    if (isAssistantReviewPortal()) return <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<Protected><Layout /></Protected>}>
            <Route path="/assistant-history" element={<Protected roles={ASSISTANT_REVIEW_ROLES}><AssistantHistoryPage /></Protected>} />
            <Route path="/assistant-feedback" element={<Protected roles={ASSISTANT_REVIEW_ROLES}><AssistantFeedbackPage /></Protected>} />
            <Route path="*" element={<Navigate to="/assistant-history" replace />} />
        </Route>
    </Routes>;
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route
                element={
                    <Protected>
                        <Layout />
                    </Protected>
                }
            >
                <Route path="/" element={<Navigate to="/news" replace />} />
                <Route path="/news" element={<NewsList />} />
                <Route path="/news/new" element={<NewsEdit mode="create" />} />
                <Route path="/news/:id" element={<NewsEdit mode="edit" />} />
                <Route path="/admin/promos" element={<PromoList />} />
                <Route path="/admin/promos/:id" element={<PromoForm />} />
                <Route path="/assistant-feedback" element={<Protected roles={ASSISTANT_REVIEW_ROLES}><AssistantFeedbackPage /></Protected>} />
                <Route path="/assistant-history" element={<Protected roles={ASSISTANT_REVIEW_ROLES}><AssistantHistoryPage /></Protected>} />
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
};

export default App;
